import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { ModalComponent } from '../components/modal/modal.component';
import { User } from '../models/user';
import { CustomerService } from '../services/customer.service';
import { UserService } from '../services/user.service';
import { CanActivateAuthGuard } from './can-activate-auth-guard';

@Injectable({
	providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
	public currentDriver: any;
	public selectedCustomer: any;
	public user: User;

	constructor(private _authGuard: CanActivateAuthGuard,
				private _userService: UserService,
				private _dialog: MatDialog,
				private _customerService: CustomerService) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		return this._authGuard.canActivate(route, state).then((auth: boolean) => {
			this.user = this._userService.getUser();
			if (this.user && this.user.type === 'worker' && this.user.driverId) {
				this.currentDriver = this.user.associatedDrivers.find((ad) => ad.id === this.user.driverId);
			}
			if (!auth) {
				return Promise.resolve(false);
			} else {
				this.selectedCustomer = this._customerService.getSelectedCustomer();
				switch (true) {
					case (state.url.includes('/home')):
					case (state.url.includes('/register')):
					case (state.url.includes('/track-order') && ((!this.user?.token && this.user?.globalSettings?.trackingOptions?.isActive) || (this.user?.type === 'inet' && this.selectedCustomer?.billingStatus !== 'CREDIT_HOLD'))):
					case (state.url.includes('/reset')):
					case (state.url.includes('/custom-page')):
					case (state.url.includes('/attachments')):
					case (state.url.includes('/track-parcel') && this.user?.type === 'inet' && (this.user?.inetUser?.allowTrackOrder || this.user?.licenses?.xRouteEnabled) && this.selectedCustomer?.billingStatus !== 'CREDIT_HOLD'):
					case (state.url.includes('/place-order') && this.user?.type === 'inet' && this.selectedCustomer?.billingStatus !== 'CREDIT_HOLD'):
					case (state.url.includes('/order-confirmation') && this.user?.type === 'inet' && this.selectedCustomer?.billingStatus !== 'CREDIT_HOLD'):
					case (state.url.includes('/reports') && this.user?.type === 'inet' && this.user?.inetUser?.viewAccountReports && this.selectedCustomer?.billingStatus !== 'CREDIT_HOLD'):
					case (state.url.includes('/route-tracking') && this.user?.type === 'inet' && this.user?.inetUser?.viewRouteStops && this.user?.licenses?.xRouteEnabled && this.selectedCustomer?.billingStatus !== 'CREDIT_HOLD'):
					case (state.url.includes('/address-book') && this.user?.type === 'inet' && this.user?.inetUser?.allowAddressBookAccess && this.selectedCustomer?.billingStatus !== 'CREDIT_HOLD'):
					case (state.url.includes('/order-templates') && this.user?.type === 'inet' && this.user?.allowRecentTemplates && this.selectedCustomer?.billingStatus !== 'CREDIT_HOLD'):
					case (state.url.includes('/invoices') && this.user?.type === 'inet' && this.user?.globalSettings?.displayInvoices && this.user?.inetUser?.viewInvoices):
					case (state.url.includes('/user-profile') && (this.user?.type === 'inet' && this.user?.canViewOwnProfile && this.selectedCustomer?.billingStatus !== 'CREDIT_HOLD') || this.user?.type === 'worker'):
					case (state.url.includes('/work') && this.user?.type === 'worker' && this.currentDriver?.canViewManifests):
					case (state.url.includes('/settlements') && this.user?.type === 'worker'):
					case (state.url.includes('/estimated-settlements') && this.user?.type === 'worker'):
						return Promise.resolve(true);
					default:
						if (state.url.includes('/route-tracking') && this.user?.type === 'inet' && (!this.user?.inetUser?.viewRouteStops || !this.user?.licenses?.xRouteEnabled)) {
							this._dialog.open(ModalComponent, {
								data: {
									title: 'Alert',
									message: 'You currently do not have permission to view routes. Please contact customer service for assistance in enabling this feature.',
									showCancel: false
								}
							});
						}
						return Promise.resolve(false);
				}
			}
		});
	}
}

